import React from "react";
import { useStaffModel } from "../staffModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useStaffModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            // placeholder: "员工姓名",
            placeholder: Locale["Employee"],
            fieldName: "name"
        },
    ]
    const PageHeaderTitle = <>
    <span style={{ color: "#7F7F7F" }}>{Locale["System Settings"]} </span>
    <span style={{ color: "#000" }}>/ {Locale["Employee Settings"]}</span>
</>
    return (
        <YhPageHeader
            title={PageHeaderTitle}
            justify="end"
            triggerSearch={true}
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}